import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Toast from '../../../components/Common/Toast';
import { getOrdersMock, MOCK_ZONAS, setOrdersMock } from './mockOperaciones';

const Pedidos = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    setOrders(getOrdersMock());
  }, []);

  const zonesMap = useMemo(() => {
    const m = {};
    MOCK_ZONAS.forEach((z) => (m[z.id] = z));
    return m;
  }, []);

  const openDetalle = (order) => {
    if (order.tipo === 'bar') {
      navigate(`/restaurantes/operaciones/bar/${order.zoneId}`);
      return;
    }
    navigate(`/restaurantes/operaciones/mesa/${order.zoneId}/${order.mesaId}`);
  };

  const cambiarEstado = (orderId) => {
    const next = orders.map((o) => (o.id === orderId ? { ...o, estado: o.estado === 'abierto' ? 'cerrado' : 'abierto' } : o));
    setOrders(next);
    setOrdersMock(next);
    setToast({ isOpen: true, message: 'Estado actualizado (demo)', type: 'success' });
  };

  const emitirTicket = (order) => {
    setToast({
      isOpen: true,
      message: `Ticket emitido para ${order.id} (demo).`,
      type: 'success',
    });
  };

  const emitirFactura = (order) => {
    setToast({
      isOpen: true,
      message: `Factura emitida para ${order.id} (demo).`,
      type: 'info',
    });
  };

  const codigoPedido = (id) => {
    const txt = String(id || '');
    const match = txt.match(/(\d+)$/);
    if (!match) return txt.toUpperCase();
    return `PED-${match[1].padStart(4, '0')}`;
  };

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-6 flex items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Pedidos</h1>
          <p className="text-gray-600 text-sm mt-1">
            Listado de pedidos. En demo se usan datos en memoria/localStorage.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            className="px-4 py-2 bg-teal-600 text-white rounded-md text-sm font-medium hover:bg-teal-700"
            onClick={() => navigate('/restaurantes/operaciones/acceso')}
          >
            Acceso mesas y barras
          </button>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
          <h2 className="font-semibold text-gray-800">Listado de pedidos (demo)</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50 text-gray-700">
              <tr>
                <th className="text-left px-4 py-3 font-medium">Código</th>
                <th className="text-left px-4 py-3 font-medium">Zona</th>
                <th className="text-left px-4 py-3 font-medium">Mesa / Barra</th>
                <th className="text-left px-4 py-3 font-medium">Mozo</th>
                <th className="text-left px-4 py-3 font-medium">Estado</th>
                <th className="text-left px-4 py-3 font-medium">Total</th>
                <th className="text-right px-4 py-3 font-medium w-[220px]">Acciones</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {orders.length === 0 ? (
                <tr>
                  <td colSpan={7} className="px-4 py-10 text-center text-gray-500">
                    No hay pedidos en demo.
                  </td>
                </tr>
              ) : (
                orders
                  .slice()
                  .sort((a, b) => String(b.createdAt).localeCompare(String(a.createdAt)))
                  .map((o) => {
                    const total = (o.items || []).reduce((s, it) => s + Number(it.precio) * Number(it.cantidad), 0);
                    const zona = zonesMap[o.zoneId]?.nombreZona || o.zoneId;
                    const mesaLabel = o.tipo === 'bar' ? 'Barra' : `Mesa ${o.mesaId}`;
                    return (
                      <tr key={o.id} className="hover:bg-gray-50">
                        <td className="px-4 py-3 font-mono text-xs text-gray-700">{codigoPedido(o.id)}</td>
                        <td className="px-4 py-3">{zona}</td>
                        <td className="px-4 py-3">{mesaLabel}</td>
                        <td className="px-4 py-3 text-gray-800">{o.mozo ? o.mozo : '—'}</td>
                        <td className="px-4 py-3">
                          <span
                            className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${
                              o.estado === 'abierto' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'
                            }`}
                          >
                            {o.estado === 'abierto' ? 'Abierto' : 'Cerrado'}
                          </span>
                        </td>
                        <td className="px-4 py-3 font-medium">S/ {total.toFixed(2)}</td>
                        <td className="px-4 py-3 text-right">
                          <div className="flex justify-end gap-2">
                            <button
                              type="button"
                              className="text-sm text-teal-700 hover:text-teal-900 font-medium"
                              onClick={() => openDetalle(o)}
                            >
                              Ver
                            </button>
                            <button
                              type="button"
                              className="text-sm text-gray-700 hover:text-gray-900 font-medium"
                              onClick={() => cambiarEstado(o.id)}
                            >
                              Cambiar estado
                            </button>
                            {o.estado === 'cerrado' ? (
                              <>
                                <button
                                  type="button"
                                  className="text-sm px-3 py-1 rounded-md bg-slate-700 text-white font-medium hover:bg-slate-800"
                                  onClick={() => emitirTicket(o)}
                                >
                                  Emitir ticket
                                </button>
                                <button
                                  type="button"
                                  className="text-sm px-3 py-1 rounded-md bg-indigo-600 text-white font-medium hover:bg-indigo-700"
                                  onClick={() => emitirFactura(o)}
                                >
                                  Emitir factura
                                </button>
                              </>
                            ) : null}
                          </div>
                        </td>
                      </tr>
                    );
                  })
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Toast
        isOpen={toast.isOpen}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ ...toast, isOpen: false })}
      />
    </div>
  );
};

export default Pedidos;

